/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var Tabs = /** @class */ (function () {
        function Tabs(config) {
            this.allTabs = config.allTabs;
            this.activeTabIndex = 0;
        }
        Tabs.create = function (config) {
            return new Tabs(config).run();
        };
        Tabs.prototype.run = function () {
            var _this = this;
            if (!this.allTabs) {
                return;
            }
            this.wrapTabs();
            this.removeFirstChild();
            document.querySelectorAll('.tabNav').forEach(function (nav) {
                _this.setNavEvents(nav);
            });
        };
        Tabs.createWrapper = function () {
            var wrapper = document.createElement('div');
            wrapper.classList.add('tiny-tabs');
            return wrapper;
        };
        Tabs.prototype.wrapTabs = function () {
            var _this = this;
            var tabsToAdd = [];
            var tabSectionCount = 0;
            var previousSibling;
            var parent;
            this.allTabs.forEach(function (tab) {
                tabsToAdd.push(tab);
                parent = tab.parentElement;
                var nextSibling = tab.nextElementSibling;
                if (nextSibling === null || (nextSibling.tagName !== 'SECTION' && !nextSibling.classList.contains('tab'))) {
                    var wrapper_1 = Tabs.createWrapper();
                    tabsToAdd.forEach(function (tabToAdd, index) {
                        previousSibling = tab.previousElementSibling;
                        var id = Tabs.safeCssId(tabToAdd.firstElementChild.textContent, tabSectionCount.toString());
                        tabToAdd.id = id + '-tab';
                        tabToAdd.setAttribute('role', 'tabpanel');
                        tabToAdd.setAttribute('aria-labelledby', id);
                        tabToAdd.setAttribute('tabindex', '0');
                        index > 0 ? tabToAdd.hidden = true : tabToAdd.hidden = false;
                        wrapper_1.appendChild(tabToAdd);
                    });
                    previousSibling === null ? parent.prepend(wrapper_1) : previousSibling.after(wrapper_1);
                    wrapper_1.prepend(_this.createTabNav(wrapper_1, tabSectionCount));
                    tabsToAdd = [];
                    tabSectionCount++;
                }
            });
        };
        Tabs.prototype.createTabNav = function (wrapper, tabSectionCount) {
            var _this = this;
            var nav = document.createElement('div');
            nav.classList.add('tabNav');
            nav.setAttribute('role', 'tablist');
            wrapper.querySelectorAll('section.tab').forEach(function (tab, index) {
                nav.appendChild(_this.createNavButton(Boolean(index), tab, tabSectionCount));
            });
            return nav;
        };
        Tabs.prototype.createNavButton = function (first, tab, tabSectionCount) {
            var button = document.createElement('button');
            button.setAttribute('role', 'tab');
            button.setAttribute('aria-selected', first ? 'false' : 'true');
            button.setAttribute('aria-controls', tab.id);
            button.setAttribute('id', 'btn-' + Tabs.safeCssId(tab.firstElementChild.textContent, tabSectionCount));
            if (first) {
                this.activeTabIndex = 0;
                button.setAttribute('tabindex', '-1');
            }
            button.innerText = tab.firstElementChild.textContent;
            return button;
        };
        Tabs.prototype.removeFirstChild = function () {
            this.allTabs.forEach(function (tab) {
                if (tab.children[0]) {
                    tab.removeChild(tab.children[0]);
                }
            });
        };
        Tabs.safeCssId = function (str, postfix) {
            return encodeURIComponent(str)
                .toLowerCase()
                .replace(/\.|%[0-9a-z]{2}/gi, '') + postfix;
        };
        Tabs.prototype.setNavEvents = function (nav) {
            var _this = this;
            nav.querySelectorAll('button').forEach(function (el) {
                util.delegate(el, 'click', 'body', function (e) {
                    _this.clickEventListener(e);
                });
                util.delegate(el, 'keydown', 'body', function (e) {
                    _this.keydownEventListener(e);
                });
            });
        };
        Tabs.prototype.clickEventListener = function (event) {
            var tab = event.target;
            this.activateTab(tab, false);
        };
        Tabs.prototype.activateTab = function (tab, setFocus) {
            setFocus = setFocus || true;
            this.deactivateTabs(tab);
            tab.removeAttribute('tabindex');
            tab.setAttribute('aria-selected', 'true');
            var controls = tab.getAttribute('aria-controls');
            document.getElementById(controls).removeAttribute('hidden');
            if (setFocus) {
                tab.focus();
            }
        };
        Tabs.prototype.deactivateTabs = function (tab) {
            var children = tab.parentElement.childNodes;
            children.forEach(function (navtab) {
                navtab.setAttribute('tabindex', '-1');
                navtab.setAttribute('aria-selected', 'false');
                var panel = document.getElementById(navtab.getAttribute('aria-controls'));
                panel.setAttribute('hidden', 'hidden');
            });
        };
        Tabs.prototype.keydownEventListener = function (e) {
            if (e.code === 'ArrowRight') {
                var tab = e.target.nextSibling;
                if (tab !== null && tab.hasAttribute('id')) {
                    this.activateTab(tab, true);
                    this.activeTabIndex = this.activeTabIndex + 1;
                }
            }
            if (e.code === 'ArrowLeft') {
                var tab = e.target.previousSibling;
                if (tab !== null && tab.hasAttribute('id')) {
                    this.activateTab(tab, true);
                    this.activeTabIndex = this.activeTabIndex - 1;
                }
            }
            if (e.code === 'ArrowDown') {
                var tab = e.target;
                e.preventDefault();
                var section = document.getElementById(tab.getAttribute('aria-controls'));
                console.log(section);
                section.focus({
                    preventScroll: false,
                });
            }
        };
        return Tabs;
    }());
    MoyaEventHandler.on('modal.opened', function (e) {
        var allTabs = e.modal.element.querySelectorAll('section.tab');
        if (allTabs.length > 0) {
            var tabConfig = {
                allTabs: allTabs
            };
            Tabs.create(tabConfig);
        }
    });
    function initTabs() {
        checkForTabs();
    }
    function checkForTabs() {
        var allTabs = document.querySelectorAll('section.tab');
        if (allTabs.length > 0) {
            var tabConfig = {
                allTabs: allTabs
            };
            Tabs.create(tabConfig);
        }
    }
    initTabs();

    exports.Tabs = Tabs;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
